var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"high-level"},[_c('h1',{style:({ color: _vm.myColors.foreground })},[_c('span',[_vm._v(_vm._s(_vm.spitTitle().first))]),_c('Times'),_c('span',[_vm._v(_vm._s(_vm.spitTitle().second))])],1),_c('p',{staticClass:"summary",style:({ color: _vm.myColors.foreground })},[_vm._v(_vm._s(_vm.summary))])])
}
var staticRenderFns = []

export { render, staticRenderFns }